<template lang="pug">
    .settings(v-if='localSettings.length')
        template(v-for="(settings, index) in localSettings")
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_category') }}: {{ $i18n.t(`trainer.trainer_gameFormSetting_${settings.category}`)  }}
            br
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_rule') }}: {{ $i18n.t(`trainer.trainer_gameFormSetting_${settings.rule}`)  }}
            br
            span(v-if="settings.rule === 'vocabularyWords'")
                | {{ $i18n.t('battle.battle_battleForm_grades') }}: {{ classes }}
            br(v-if="settings.rule === 'vocabularyWords'")
            span(v-if="settings.rule === 'vocabularyWords'")
                | {{ $i18n.tc('trainer.trainer_gameFormSetting_letters', 1) }}: {{ letters }}
            br(v-if="settings.rule === 'vocabularyWords'")
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}: {{ $i18n.t(`trainer.trainer_gameFormSetting_${settings.mode}`)}}
            br
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_playbackSpeed') }}: {{ settings.playbackSpeed }}
            br
            span(v-if='settings.amountOfExamples && !settings.timeLimit')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}: {{ settings.amountOfExamples }}
            br(v-if='settings.amountOfExamples && !settings.timeLimit')
            span(v-if='settings.timeLimit')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}:
                | {{ settings.timeLimit }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_minutes') }}
            br(v-if='settings.timeLimit')
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_showingCorrectAnswers') }}: {{ $i18n.t(settings.showAnswer ? 'trainer.trainer_gameFormSettingValue_onAbbreviated' : 'trainer.trainer_gameFormSettingValue_offAbbreviated')  }}
            br
            span(v-if="formattedSourceText")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_ownText') }}: {{ formattedSourceText }}
            br(v-if="formattedSourceText")
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';
    import { getFormattedDate } from '../../../utils/getFormattedDate';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
        },
        data() {
            return {
                localSettings: [],
            };
        },
        computed: {
            formattedSourceText() {
                if (!this.settings.sourceText) return '';
                if (this.settings.sourceText.length <= 20) {
                    return this.settings.sourceText;
                }
                return this.settings.sourceText?.split('', 20).join('') + '...';
            },
            classes() {
                return this.settings.chosenClasses
                    .map(obj => this.$i18n.t('trainer.trainer_gameFormSetting_' + `${obj}`))
                    .join('; ');
            },
            letters() {
                return this.settings.chosenLetters.map(obj => `${obj}`).join('; ');
            },
        },
        watch: {
            settings: {
                handler(val) {
                    this.localSettings = Array.isArray(val) ? val : [val];
                },
                immediate: true,
            },
        },
        methods: {
            getFormattedDate,
        },
    };
</script>
